var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offline)?_c('div',{staticClass:"alert alert-danger offline-message"},[_c('span',[_vm._v("Вы не подключены к интернету. Восстановите соединение, чтобы продолжить.")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }